// extracted by mini-css-extract-plugin
export default {"container":"wUVkiI","horizontalSnap":"lJxl72","dots":"Yh1vfg","outside":"BGS_m0","previous":"NrbE9h","next":"eDe4uM","invertedArrow":"HvRWaw","disabledArrow":"X8GenN"};